/** Display helpers for the staff dashboard. Pure, so they are unit-tested. */

export function fmtInt(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : n.toLocaleString('en-US');
}

/** Null means "no denominator", which must not read as 0%. */
export function fmtPercent(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `${n}%`;
}

export function fmtUsd(n: number): string {
  // Sub-cent spend is the normal case for gpt-4o-mini-class calls; rounding it
  // to $0.00 would make a working meter look broken.
  if (n > 0 && n < 0.01) return `$${n.toFixed(4)}`;
  return `$${n.toFixed(2)}`;
}

/** Turn a status key into a label. */
export function statusLabel(k: string): string {
  return k.charAt(0).toUpperCase() + k.slice(1);
}

/** Change between the first and last point of a series, as a signed integer. */
export function seriesDelta(values: number[]): number {
  return values.length < 2 ? 0 : values[values.length - 1] - values[0];
}

/** SVG polyline points for a sparkline in a w×h box. A flat series draws mid-height. */
export function sparkPoints(values: number[], w: number, h: number): string {
  if (values.length === 0) return '';
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min;
  const step = values.length > 1 ? w / (values.length - 1) : 0;
  return values
    .map(
      (v, i) =>
        `${(i * step).toFixed(1)},${(span === 0 ? h / 2 : h - ((v - min) / span) * h).toFixed(1)}`,
    )
    .join(' ');
}
